export const HANDBOOK_INITIAL_LOAD_COUNT = 100;
export const HANDBOOK_SHOW_MORE_LIMIT = 100;

export const TEMPLATE_APPLY_EDITINGS_LOADER_TEXT = "Редактируем шаблоны";
export const SEGMENTS_APPLY_EDITINGS_LOADER_TEXT = "Редактируем атрибуты";

